module.exports = __webpack_public_path__ + "img/Metastasis-BRME_GSE179572.42e7a999.png";